/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NegotiationServicesAliases {
  AUTOCOMPLETE_0 = 'autocomplete-0',
  AVATAR_0 = 'avatar-0',
  AVATAR_SERVICE = 'avatar-service',
  CARD_SERVICE = 'card-service',
  CHECKBOX_0 = 'checkbox-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_SERVICES = 'deck-services',
  FETCH_ORIGIN = 'fetch-origin',
  FETCH_SERVICE = 'fetch-service',
  FETCH_SERVICES = 'fetch-services',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_AVATAR = 'field-avatar',
  FIELD_CODE = 'field-code',
  FIELD_COUNTER_OFFER_VALUE = 'field-counter-offer-value',
  FIELD_CP_VALUE = 'field-cp-value',
  FIELD_DESCRIPTION = 'field-description',
  FIELD_MATERIAL_VALUE = 'field-material-value',
  FIELD_ORIGIN = 'field-origin',
  FIELD_SEQ = 'field-seq',
  FILTER_0 = 'filter-0',
  FILTERED_LIST_0 = 'filtered-list-0',
  FORM_SERVICE = 'form-service',
  INPUT_CODE = 'input-code',
  INPUT_CP_VALUE = 'input-cp-value',
  INPUT_DESCRIPTION = 'input-description',
  LEGENDS = 'legends',
  MAPPER_0 = 'mapper-0',
  MAPPER_AVATAR = 'mapper-avatar',
  MAPPER_ORIGIN = 'mapper-origin',
  MODAL_SERVICE = 'modal-service',
  PANEL_0 = 'panel-0',
  PANEL_MODAL_SERVICE = 'panel-modal-service',
  PANEL_SERVICES = 'panel-services',
  TEXT_0 = 'text-0',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_ORIGIN = 'text-origin',
  TEXT_SEQ = 'text-seq',
}
export { NegotiationServicesAliases };
